/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';

import styles from '../../../../styles';
import Localized from '../../../../../shared/components/Localized';
import { StatusIcon } from '../../../../components/SVGIcon';
import { Checkbox } from '../../../../components/Form';


const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin: 0 0 1.25rem;

  @media (min-width: 768px)  {
    margin: 1rem 0;
    border: 1px solid #d8dde6;
  }
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid #d8dde6;
  }
`;


const Cell = styled.div`
  flex: 1 0 33%;
  text-align: center;
  padding: 0.5rem 0;
  ${styles.fonts.headingLabel}

  &:not(:last-child) {
    border-right: 1px solid #d8dde6;
  }
`;

const StatusIconWithMargin = styled(StatusIcon)`
  margin-right: 0.5rem;
`


const severities = [
  {
    key: 'major',
    localizationKey: 'disruption',
    imgUrl: '/assets/icons/icon-major.png'
  },
  {
    key: 'minor',
    localizationKey: 'degradation',
    imgUrl: '/assets/icons/icon-minor.png'
  },
  {
    key: 'maintenance',
    localizationKey: 'maintenance',
    imgUrl: '/assets/icons/icon-maintenance.png'
  }
];

const allSeverities = (s) => s.major && s.minor && s.maintenance;
const someSeverities = (s) => s.major || s.minor || s.maintenance;

export default class AllSeverityGrid extends React.Component {
  static propTypes = {
    instanceSubscription: PropTypes.object,
    severities: PropTypes.array,
    services: PropTypes.array,
    clickAllServices: PropTypes.func,
    clickService: PropTypes.func,
    clickseverity: PropTypes.func,
    readOnly: PropTypes.bool,
    invalid: PropTypes.bool
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { severityGrid: { state, actions: { toggleAll, toggleSeverity } } } = this.props;

    return (
      <Grid className={this.props.className}>
        <Row>
          { severities.map((severity, i) =>  (
            <Cell key={i}>
              <StatusIconWithMargin size='1rem' severity={severity.key} />
              <Localized modelName={'statusKey'} modelKey={severity.localizationKey} modelAttribute={'label'} />
            </Cell>
          ))}
        </Row>
        <Row>
          { severities.map((severity, i) => (
            <Cell key={i}>
              <Checkbox
                name={`${severity.key}`}
                id={`${severity.key}`}
                checked={state[severity.key]}
                value={state[severity.key]}
                onChange={(value) => toggleSeverity(severity.key, value)}
              />
            </Cell>
          ))}
        </Row>
      </Grid>
    );
  }
}
